import React, { Component } from 'react';
import { Grid } from 'react-bootstrap';
import Header from '../components/Header';
import Footer from '../components/Footer';

export default class Base extends Component {
  render() {
    return (
      <div className="main-container">
        <Header />
        <Grid>{this.props.children}</Grid>
        <Footer />
      </div>
    );
  }
}



// WEBPACK FOOTER //
// src/containers/Base.jsx